import { Validator } from '@vista-digital/validator';
import { SeatSelectionRuleName } from '../../types/seat-selection-rule-name';
import { hasAvailableAndNotSelectedSeatsInGroup, isSofaSeatType } from '../seat-utils';
export const defaultMustFillSofaSeatsPartialSelectionRuleOptions = {
    allowSinglePartialSofa: false
};
export const mustFillSofaSeatsPartialSelectionRuleOptionsValidator = Validator.object({
    allowSinglePartialSofa: Validator.boolean()
});
const ruleName = SeatSelectionRuleName.MustFillSofaSeats;
/**
 * Rule that prevents a sofa seat from being sold unless all available
 * seats in the sofa are selected.
 */
export const mustFillSofaSeatsRule = (options) => {
    const mergedOptions = Object.assign(Object.assign({}, defaultMustFillSofaSeatsPartialSelectionRuleOptions), options);
    return {
        name: ruleName,
        validate: (data, selectedSeats) => {
            const seatGroupMap = new Map();
            selectedSeats
                .filter(seat => isSofaSeatType(seat.type))
                .forEach(seat => {
                seatGroupMap.set(JSON.stringify(seat.seatGroupIds), seat);
            });
            const uniqueSeatGroups = [...seatGroupMap.values()];
            let partiallyFilledSofasPerGroupCount = 0;
            uniqueSeatGroups.forEach(seat => {
                if (hasAvailableAndNotSelectedSeatsInGroup(data, selectedSeats, seat)) {
                    partiallyFilledSofasPerGroupCount++;
                }
            });
            return {
                ruleName: ruleName,
                isValid: (mergedOptions.allowSinglePartialSofa && partiallyFilledSofasPerGroupCount === 1) ||
                    partiallyFilledSofasPerGroupCount === 0
            };
        }
    };
};
//# sourceMappingURL=must-fill-sofa-seats-rule.js.map